import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { VictoryLabel } from 'victory';

export default class RootCauseGraphLegend extends PureComponent {
  static propTypes = {
    categories: PropTypes.array.isRequired,
    categoryColors: PropTypes.object.isRequired,
  };

  render() {
    const {categories, categoryColors } = this.props;

    const legendBorder = 10;
    const legendX = 50; // 640; // graphW - 90;
    const legendY = 0; // 32;
    const legendW = 145 + legendBorder * 2;
    const legendH = 10 * categories.length + legendBorder;

    const legendLabelX = legendX + legendW / 2 + legendBorder;
    const legendLabelY = legendY + legendBorder;

    const legend = (<g>
      <rect
        x={legendX} y={legendY}
        width={legendW} height={legendH}
        fill="#aaa"
      />
      {categories.map((c, k) => {
        const y = legendLabelY + k * 10;
        return (
          <g
            key={k}
          >
          <VictoryLabel
            textAnchor="end"
            text={c}
            x={legendLabelX}
            y={y}
            style={{
              fill: 'black',
              fontFamily: 'inherit',
              fontSize: 8,
            }}
          />
          <line
            x1={legendLabelX + 2}
            y1={y}
            x2={legendX + legendW - legendBorder}
            y2={y}
            strokeWidth={5}
            stroke={categoryColors[c]}
          />
        </g>
        );
      })
      }
    </g>);

    return legend;
  }
}



// WEBPACK FOOTER //
// ./src/views/Project/RootCauseGraph/RootCauseGraphLegend.js